import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button } from "react-bootstrap";
import { deleteBanner, getBanners } from "../../reducers/commonReducer";
import BannersUpdate from "./BannersUpdate";
import BannersAdd from "./BannersAdd";
import { handleContextMenu, home } from "../../const";

const Banners = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("slug") === "admin" ? !localStorage.getItem("x-admin-token") : !localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(getBanners());
  }, []);

  const { getBannersData } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <div className="m-2">
          <BannersAdd />
        </div>

        <table className="table table-scrolling ">
          <thead className="normalplace">
            <tr className="tables">
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Image</th>
              <th className="over-col-size">Slug</th>
              <th className="over-col-size">Description</th>
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody className="tbody-table">
            {!!getBannersData?.list &&
              getBannersData?.list.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{data?.title}</td>
                    <td>
                      <img src={`${data?.image}`} alt="banner" onContextMenu={handleContextMenu} loading="lazy"/>
                    </td>
                    <td>{data?.slug}</td>
                    <td>{data?.description}</td>
                    <td>
                      <b>{data?.status === true ?<span className="text-white bg-success rounded px-2 f-13">True</span> : <span className="text-white bg-danger rounded px-2 f-13">False</span>}</b>
                    </td>
                    <td>
                      <BannersUpdate
                        title="Update Banner"
                        bannerName={data?.title}
                        bannerslug={data?.slug}
                        bannerdes={data?.description}
                        userStatus={data?.status}
                        id={data?.id}
                        bannerImage={data?.image}
                      />
                      <Button
                        className="m-1"
                        variant="danger"
                        onClick={async () => {
                          const deleteResp = window.confirm();
                          if(deleteResp){
                            const apiResp = await dispatch(deleteBanner(data?.id));
                            if(apiResp?.payload?.status){
                              await dispatch(getBanners());
                            }
                          }
                        }}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Banners;
